import {createSelector} from 'reselect';
import {
  getEntityType,
  isExternalLinksEnabled,
  isFreeEntity,
  isNameYourPrice,
  isSubscribeRequired,
} from './albumProvider';
import {getEntityGetRequirement} from './getEntityGetRequirement';

const albumSelector = (state) => state.album;
const trackSelector = (state) => state.track;

export const entityTypeSelector = createSelector([albumSelector, trackSelector], getEntityType);

export const isFreeSelector = createSelector([albumSelector, trackSelector], isFreeEntity);

export const isNameYourPriceSelector = createSelector([albumSelector, trackSelector], (album, track) =>
  isNameYourPrice(track ? track : album),
);

export const isSubscribeSelector = createSelector([albumSelector, trackSelector], (album, track) =>
  isSubscribeRequired(track ? track : album),
);

export const isSubscriptionRequiredSelector = createSelector([albumSelector, trackSelector], (album, track) =>
  track ? track.isSubscriptionRequired : album.isSubscriptionRequired,
);
export const getRequirementSelector = createSelector([albumSelector, trackSelector], getEntityGetRequirement);

export const hasExternalLinksSelector = createSelector([albumSelector, trackSelector], isExternalLinksEnabled);
